import React from "react";
import {
  fetchOrdersFilterChipsDisplayCount,
  fetchRoutesFilterChipsDisplayCount,
  fetchPlanningOrderListByFilter,
  fetchPlanningRouteListByFilter,
  publishRoutes,
  deleteRoute,
  clearPublishedRoutesErrors,
  clearUpdatedRoute,
  resetPlanningError,
  resetConsignmentReplanningSuccess,
  fetchDeliveryReasons,
  fetchDynamicFiltersOrdersDropdownValues,
  fetchDynamicFiltersRoutesDropdownValues,
  clearCurrentSlot,
  exportToExcel,
  exportRoutesToExcel,
  resetExportInitiated,
} from "./redux/carrefourDeliverySlice";
import { useSelector } from "react-redux";
import {
  createDeleteRoutePayload,
  createFilterPayload,
  createPublishRoutesPayload,
  getConsignmentStatusField,
  getRouteStatusField,
  CarrefourDeliveryOrdersDataTransform,
  CarrefourDeliveryRoutesDataTransform,
  createPayloadForExcelExport,
  createRoutesPayloadForExcelExport,
} from "../mocks/carrefourHomeDelivery/response.transforms";

import { AppState } from "../config/redux/reducers";
import AppConstants from "../constants";
import UACConstants from "../constants/UACConstants";
import { useUACHelper } from "../contexts/UACContext";

import CarrefourDeliveryOrderDetails from "./CarrefourDeliveryOrderDetails";
import DeliveryBaseComponent from "SharedComponent/components/deliveryComponent";

interface CarrefourDeliveryProps {
  match?: any;
  location?: any;
}

const CarrefourDelivery = (props: CarrefourDeliveryProps) => {
  const { location } = props;
  const {
    ordersData,
    routesData,
    tableLoading,
    ordersFiltersDropdowns,
    routesFiltersDropdowns,
    vtOrdersFilterChipsDisplayCount,
    routesFilterChipsDisplayCount,
    publishedRoutes,
    deletedRoute,
    publishedRoutesErrors,
    updatedRoute,
    routeDiscardSuccess,
    chdReplanningConsignmentSuccess,
    isUpdateAddress,
    loading,
    error,
    errorCode,
    exportInitiated,
    reportId,
  } = useSelector((state: AppState) => state.carrefourDelivery);

  const uacHelper = useUACHelper();

  const tabs = React.useMemo(() => {
    const availableTabs = [];

    if (uacHelper.hasAccess(UACConstants.HD_ORDERS)) {
      availableTabs.push({
        key: UACConstants.HD_ORDERS,
        label: "Orders",
        // ...existing tab config...
      });
    }

    if (uacHelper.hasAccess(UACConstants.HD_ROUTES)) {
      availableTabs.push({
        key: UACConstants.HD_ROUTES,
        label: "Routes",
        // ...existing tab config...
      });
    }

    return availableTabs;
  }, [uacHelper]);

  return (
    <DeliveryBaseComponent
      location={location}
      OrderDetailsComponent={CarrefourDeliveryOrderDetails}
      deliveryState={{
        ordersData,
        routesData,
        tableLoading,
        ordersFiltersDropdowns,
        routesFiltersDropdowns,
        ordersFilterChipsDisplayCount: vtOrdersFilterChipsDisplayCount,
        routesFilterChipsDisplayCount,
        publishedRoutes,
        deletedRoute,
        publishedRoutesErrors,
        updatedRoute,
        routeDiscardSuccess,
        replanningConsignmentSuccess: chdReplanningConsignmentSuccess,
        isUpdateAddress,
        loading,
        error,
        errorCode,
        exportInitiated,
        reportId,
      }}
      actions={{
        fetchOrdersFilterChipsDisplayCount,
        fetchRoutesFilterChipsDisplayCount,
        fetchPlanningOrderListByFilter,
        fetchPlanningRouteListByFilter,
        publishRoutes,
        deleteRoute,
        clearPublishedRoutesErrors,
        clearUpdatedRoute,
        resetPlanningError,
        resetConsignmentReplanningSuccess,
        fetchDeliveryReasons,
        fetchDynamicFiltersOrdersDropdownValues,
        fetchDynamicFiltersRoutesDropdownValues,
        clearCurrentSlot,
        exportToExcel,
        exportRoutesToExcel,
        resetExportInitiated,
      }}
      transforms={{
        createDeleteRoutePayload,
        createFilterPayload,
        createPublishRoutesPayload,
        getConsignmentStatusField,
        getRouteStatusField,
        lastMileOrdersDataTransform: CarrefourDeliveryOrdersDataTransform,
        lastMileRoutesDataTransform: CarrefourDeliveryRoutesDataTransform,
        createPayloadForExcelExport,
        createRoutesPayloadForExcelExport,
      }}
      routePath={{
        createRoute: AppConstants.ROUTES.CARREFOUR_DELIVERY_CREATE_ROUTE,
        editRoute: AppConstants.ROUTES.CARREFOUR_DELIVERY_EDIT_ROUTE,
        viewRoute: AppConstants.ROUTES.CARREFOUR_DELIVERY_VIEW_ROUTE,
      }}
    />
  );
};

export default CarrefourDelivery;
